import { render } from "./file-manager-modal.vue?vue&type=template&id=3bb1a48d"
import script from "./file-manager-modal.vue?vue&type=script&lang=js"
export * from "./file-manager-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__